import { CategoryDetailViewModel } from "@payping/api";
import { CLEAR_LIST, LOGGED_OUT } from "./constants";
import { ClearListAction, LoggedOutAction } from "./types";

export const CATEGORIES_LOADED = "CATEGORIES_LOADED";
export const CATEGORY_ITEMS_LOADED = "CATEGORY_ITEMS_LOADED";
export const CATEGORY_REMOVED = "CATEGORY_REMOVED";

export interface CategoryState {
  list: CategoryDetailViewModel[];
  totalCount: number;
}

export interface CategoriesLoadedAction {
  type: typeof CATEGORIES_LOADED;
  payload: { list: CategoryDetailViewModel[]; totalCount: number; append: boolean };
}

export interface CategoryProductsLoadedAction {
  type: typeof CATEGORY_ITEMS_LOADED;
  payload: { category: CategoryDetailViewModel };
}

export interface CategoryRemovedAction {
  type: typeof CATEGORY_REMOVED;
  payload: { code: string };
}

export type CategoryActionTypes =
  | CategoriesLoadedAction
  | CategoryProductsLoadedAction
  | ClearListAction
  | CategoryRemovedAction
  | LoggedOutAction;

const initialState: CategoryState = {
  list: [],
  totalCount: 0,
};

export default function categories(state = initialState, action: CategoryActionTypes): CategoryState {
  if (action.type === CATEGORIES_LOADED) {
    const { list, totalCount } = action.payload;
    return {
      ...state,
      list,
      totalCount,
    };
  }

  if (action.type === CATEGORY_ITEMS_LOADED) {
    const { category } = action.payload;
    const { products, code } = category;
    return {
      ...state,
      list: state.list.map((curCat) => (curCat.code === code ? { ...curCat, products } : curCat)),
    };
  }

  if (action.type === CLEAR_LIST) {
    return {
      ...state,
      list: [],
    };
  }

  if (action.type === CATEGORY_REMOVED) {
    const { code } = action.payload;
    const list = state.list.filter((item) => item.code !== code);
    const totalCount = state.totalCount - 1;

    return {
      ...state,
      list,
      totalCount,
    };
  }

  if (action.type === LOGGED_OUT) {
    return initialState;
  }

  return state;
}
